import { render, staticRenderFns } from "./beijing.vue?vue&type=template&id=32e1d3f8&scoped=true&"
import script from "./beijing.vue?vue&type=script&lang=js&"
export * from "./beijing.vue?vue&type=script&lang=js&"
import style0 from "./beijing.vue?vue&type=style&index=0&id=32e1d3f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1d3f8",
  null
  
)

export default component.exports